<style lang="less">
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  min-width: 1024px;
  //background-color: @body-background !important;
}

#app {
  height: 100%;
}
</style>

<template>
  <a-config-provider :locale="locale">
    <div id="app" ref="app">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive">

      </router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'App',
  data () {
    return {
      locale: zhCN
    }
  },
  mounted () {
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    this.$store.commit('setUser_Info', userInfo)

    // 分辨率低的浏览器缩放为100% 1440 1240
    // if (window.screen.width < 1680) {
    //   const $app = this.$refs.app
    //   $app.style.zoom = '100%'
    //   // 或者使用transform scale
    //   // $app.style.transform = "scale(1.25)";
    //   // $app.style.transformOrigin = "top left";
    // } else {
    //   const $app = this.$refs.app
    //   $app.style.zoom = '125%'
    //   // 或者使用transform scale
    //   // $app.style.transform = "scale(1.25)";
    //   // $app.style.transformOrigin = "top left";
    // }
  },
  created () {
    // 监听多账户登录
    window.addEventListener('storage', res => {
      if (res.key === 'access_token') {
        // 检测到access_token被修改，跳转登录页面
        // this.$router.push({ name: 'Login' })
        console.log('access_token', 'access_token修改')
        const vm = this
        vm.$confirm({
          title: '登录身份已变更',
          content: '检测到账号身份变更。为了数据安全，当前登录会话已失效。如需同时使用不同角色，请使用浏览器的‘无痕模式’或更换浏览器。',
          cancelButtonProps: { style: { display: 'none' } },
          onOk () {
            window.localStorage.clear()
            sessionStorage.clear()
            localStorage.clear()
            // vm.$router.push({ name: 'Login' })
            console.log(process.env.NODE_ENV)
            window.location.replace(vm.$loginUrl)
          }
        })
      } else if (res.key === 'user_info') {
        // 检测到 user_info被清除，跳转登录页面
        const userInfo = localStorage.getItem('user_info')
        if (!userInfo) {
          console.log('access_token', 'access_token修改')
          const vm = this
          vm.$confirm({
            title: '登录身份已变更',
            content: '检测到账号身份变更。为了数据安全，当前登录会话已失效。如需同时使用不同角色，请使用浏览器的‘无痕模式’或更换浏览器。',
            cancelButtonProps: { style: { display: 'none' } },
            onOk () {
              window.localStorage.clear()
              sessionStorage.clear()
              localStorage.clear()
              // vm.$router.push({ name: 'Login' })
              console.log(process.env.NODE_ENV)
              window.location.replace(vm.$loginUrl)
            }
          })
        }
      }
    })
  }
}
</script>

<style lang="css" src="./assets/common.css"></style>
